"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buttonIconSizes = exports.buttonIconVariants = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SystemIcon = _interopRequireDefault(require("../../../protons/icons/SystemIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var colorIconMap = {
  primary: "white",
  secondary: "white",
  tertiary: "grey",
  selected: "white",
  transparentWhite: "white",
  transparentRed: "red",
  transparentGrey: "grey"
};
var sizeIconMap = {
  small: "default",
  medium: "default",
  large: "large",
  xlarge: "large"
};
/**
 * **Buttons allow users to take actions, and make choices, with a single tap.**
 *
 * There are 7 variants: Primary, Secondary, Tertiary, Selected, TransparentWhite, TransparentRed, TransparentGrey
 *
 * There are 4 sizes: Medium, Small, Large, X-Large
 *
 * There is a disabled state
 *
 * There is a rounded variant
 */

var ButtonIcon = function ButtonIcon(_ref) {
  var action = _ref.action,
      icon = _ref.icon,
      variant = _ref.variant,
      disabled = _ref.disabled,
      size = _ref.size,
      rounded = _ref.rounded;
  var themeProps = {
    "primary": {
      "variant": "contained",
      "color": "primary",
      "className": (0, _classnames.default)({
        "MuiButton-containedRounded": rounded,
        "MuiButton-containedIcon": true,
        "MuiButton-containedSizeXLarge": size === "xlarge"
      })
    },
    "secondary": {
      "variant": "contained",
      "className": (0, _classnames.default)({
        "MuiButton-containedRounded": rounded,
        "MuiButton-containedIcon": true,
        // "MuiButton-containedTransparent": transparent,
        "MuiButton-containedSizeXLarge": size === "xlarge"
      })
    },
    "tertiary": {
      "variant": "contained",
      "className": (0, _classnames.default)({
        "MuiButton-containedRounded": rounded,
        "MuiButton-containedWhite": true,
        "MuiButton-containedIcon": true,
        // "MuiButton-containedTransparent": transparent,
        "MuiButton-containedSizeXLarge": size === "xlarge"
      })
    },
    "selected": {
      "variant": "contained",
      "className": (0, _classnames.default)({
        "MuiButton-containedRounded": rounded,
        "MuiButton-containedIcon": true,
        // "MuiButton-containedTransparent": transparent,
        "MuiButton-containedSelected": true,
        "MuiButton-containedSizeXLarge": size === "xlarge"
      })
    },
    "transparentWhite": {
      "variant": "contained",
      "className": (0, _classnames.default)({
        "MuiButton-containedRounded": true,
        "MuiButton-containedTransparent": true,
        "MuiButton-containedIcon": true,
        "MuiButton-containedSizeXLarge": size === "xlarge"
      })
    },
    "transparentRed": {
      "variant": "contained",
      "className": (0, _classnames.default)({
        "MuiButton-containedRounded": true,
        "MuiButton-containedTransparent": true,
        "MuiButton-containedIcon": true,
        "MuiButton-containedSizeXLarge": size === "xlarge"
      })
    },
    "transparentGrey": {
      "variant": "contained",
      "className": (0, _classnames.default)({
        "MuiButton-containedRounded": true,
        "MuiButton-containedTransparent": true,
        "MuiButton-containedIcon": true,
        "MuiButton-containedSizeXLarge": size === "xlarge"
      })
    }
  };
  var sizeProps = {
    "small": {
      size: "small"
    },
    "medium": {
      size: "medium"
    },
    "large": {
      size: "large"
    },
    "xLarge": {}
  };
  return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({}, themeProps[variant], sizeProps[size], {
    onClick: function onClick(event) {
      return action && action(event);
    },
    disableElevation: true,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
    icon: icon,
    color: colorIconMap[variant],
    size: sizeIconMap[size]
  }));
};

var buttonIconVariants = ['primary', 'secondary', 'tertiary', 'selected', "transparentWhite", "transparentRed", "transparentGrey"];
exports.buttonIconVariants = buttonIconVariants;
var buttonIconSizes = ['small', 'medium', 'large', 'xlarge'];
exports.buttonIconSizes = buttonIconSizes;
ButtonIcon.propTypes = {
  /** The available colour variants of the button (transparent variant is always rounded)  */
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'tertiary', 'selected', "transparentWhite", "transparentRed", "transparentGrey"]),

  /** The size variant of the button (32px, 40px, 48px, 60px) */
  size: _propTypes.default.oneOf(['small', 'medium', 'large', 'xlarge']),

  /** The icon of the button from SystemIconKeys */
  icon: _propTypes.default.string.isRequired,

  /** A Rounded variant of the button */
  rounded: _propTypes.default.bool,

  /** The disable state of the button */
  disabled: _propTypes.default.bool,

  /** Action that will called on click */
  action: _propTypes.default.func.isRequired
};
ButtonIcon.defaultProps = {
  variant: "primary",
  size: "medium",
  rounded: false,
  disabled: false
};
var _default = ButtonIcon;
exports.default = _default;